import { render, staticRenderFns } from "./NodeModal.vue?vue&type=template&id=4b485560&"
import script from "./NodeModal.vue?vue&type=script&lang=js&"
export * from "./NodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports